// 西班牙语
import constant from '../../constants/lang/es';
import newLang from '../newLang/es';
/* eslint-disable max-len */
export default {
  cfmoto: {
    ...(newLang.cfmoto || {}),
    constant,
    api: {
      http: {
        401: 'Primero inicie sesión',
        404: 'Sin datos',
        500: 'El sistema está ocupado, inténtalo de nuevo más tarde',
        504: 'Tiempo de espera agotado',
        ERR_NETWORK: 'Excepción de red',
        ERR_NETWORK_UPLOAD: 'La carga falló, intente con otra red',
      },
    },
    title: 'Intemet International',
    navbar: {
      dropdown: {
        updatePassword: 'update password',
        switchLanguage: 'switch language',
        logout: 'log out',
      },
    },
    router: {
      title: {
        'binding-agreement': '绑车协议',
        introduce: '介绍',
        lamp: 'Luz indicadora',
        download: 'CFMOTO RIDE APP Download',
        orderConfirm: 'Order Confirmation',
        ebook: 'ebook',
        list: 'ebook',
        pdf: 'PDF',
        feedback: 'Registros',
        'feedback-create': 'Comentarios',
        'feedback-supplement': 'Comentarios adicionales',
        'feedback-detail': 'Detalles de los comentarios',
        'feedback-result': 'Comentarios',
        guide: 'Centro de ayuda',
        'guide-restScreen': 'Cómo Cómo configurar el vehículoel salpicadero instrucciones',
        'guide-overview': 'Resumen de funciones',
        'guide-account': 'Acerca de la cuenta',
        'guide-vehicle': 'Sobre el vehículo',
        'guide-meterSetting': 'Cómo configurar el salpicadero',
        'guide-vehicleSetting': 'Cómo Cómo configurar el vehículoel salpicadero',
        'guide-findNavigation': 'Cómo navegar para encontrar el vehículo',
        'guide-vehicleNnavigation': 'Cómo utilizar la navegación',
        'guide-cyclingRecord': 'Sobre el historial de conducción',
        'guide-vehicleExperience': 'Cómo realizar una autoinspección del vehículo',
        'guide-useSetting': 'Cómo hacer la configuración general de la aplicación',
        'guide-notice': 'Cómo ver y configurar la notificación de mensajes',
        'guide-about': 'Acerca de la aplicación',
        help: 'Ayuda y comentarios',
        'help-detail': 'Detalles de la pregunta',
        'myCar-unbinding': 'Aplicar la desvinculación',
        'myCar-unbinding-result': 'Aplicar la desvinculación',
      },
    },
    form: {
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      submit: 'Enviar',
      search: 'Buscar',
      language: {
        languageCode: {
          label: 'select language',
          placeholder: 'please select language',
        },
      },
    },
    rules: {
      language: {
        languageCode: {
          required: 'please select language',
        },
      },
    },
    dialog: {
      language: 'select language',
    },
    binding: {
      title: `Protocolo`,
      text1: '1.	Servicios Telemáticos',
      text2:
        'CFMOTO Powersports, Inc. (en adelante, " CFMOTO " ) proporciona servicios telemáticos para vehículos al cliente que compró el vehículo CFMOTO (en adelante, "Cliente" ). Para estos servicios, CFMOTO utiliza datos registrados por el Vehículo sobre el Vehículo y su comportamiento de conducción en el período de tiempo correspondiente. En detalle, esto se refiere a los siguientes datos:',
      text3: 'Datos de comportamiento de conducción del usuario : incluida la aceleración, desaceleración, velocidad, curvas, último tiempo de conducción y último kilometraje de conducción .',
      text4:
        'Datos de estado del vehículo: se refiere al estado en tiempo real del vehículo, incluido el modo de conducción, el combustible residual, el ahorro instantáneo de combustible, el kilometraje, la marcha en tiempo real del vehículo, la velocidad del motor, la presión de los neumáticos, la temperatura de los neumáticos, los datos de voltaje de activación de la batería , temperatura del refrigerante, estado de la cerradura electrónica, versión del software del dispositivo inteligente, intensidad de la señal de los dispositivos inteligentes, configuración actual del tablero.',
      text5:
        'Datos de alarma del vehículo: datos de alarma que se enviarán si ciertos datos exceden un valor preestablecido, como temperatura del motor, velocidad excesiva, tiempo de conducción excesivo, temperatura alta del refrigerante, movimiento anormal del vehículo, presión anormal de los neumáticos, vibración, descarga, colisión , etc. .',
      text6: 'Información de Falla del Vehículo: se refiere a los códigos de falla reportados por cada parte interna del Vehículo.',
      text7: 'Datos de Ubicación del Vehículo: se refiere al paradero geográfico específico del Vehículo.',
      text8: '1.1.	proporcionando _ el Cliente con servicios relacionados con el vehículo a través de la APLICACIÓN CFMOTO RIDE .',
      text9: '1.1.1.	APLICACIÓN CFMOTO RIDE (incluida la visualización de la ubicación del vehículo, la configuración de la información y las funciones del vehículo, el control remoto del estado del vehículo, etc.).',
      text10: '1.1.2.	Proporcionar planificación de rutas durante la navegación, incluido el cálculo de la distancia entre vehículos y la navegación a pie con el fin de encontrar un vehículo .',
      text11: '1.2.	Envío de las notificaciones necesarias al Cliente en función de las condiciones del vehículo.',
      text12:
        '1.2.1.	CFMOTO enviará notificaciones al Cliente sobre el mantenimiento del vehículo (por ejemplo, en función de la distancia total que condujo el Cliente, el momento en que el Cliente compró el vehículo, el tiempo o los requisitos de distancia de conducción para el mantenimiento del vehículo) .',
      text13:
        '1.2.2.	Con base en los datos del vehículo , CFMOTO enviará al Cliente notificaciones de situaciones anormales; incluyendo análisis de datos por OEM (dependiendo del modelo) para brindar atención al cliente y optimización del seguimiento del vehículo .',
      text14: '1.3.	Apoyo en el análisis de la causa del accidente si el Cliente reporta un accidente grave del Vehículo.',
      text15:
        '1.3.1.	En caso de un accidente grave del Vehículo, como cuando el Vehículo vuelca o vuelca sobre un costado mientras conduce, CFMOTO ayudará al Cliente, previa solicitud, a aclarar si el accidente se debe a un defecto en el Vehículo u otras circunstancias. La solicitud debe ser enviada a CFMOTO por el Cliente a través del distribuidor local / socio de ventas indicado en el Acuerdo de Venta de Vehículos.',
      text16: '1.3.2.	En la medida en que los datos disponibles lo permitan, CFMOTO evaluará los datos en relación con la causa del accidente y entregará al Cliente el informe correspondiente.',
      text17: '1.4.	Asistencia al Cliente para recuperar el Vehículo después de la pérdida del Vehículo .',
      text18:
        '1.4.1.	Si se pierde el Vehículo, CFMOTO proporcionará al Cliente los datos de ubicación del Vehículo y otros datos útiles sobre el estado del Vehículo (como la ubicación de la última activación, el estado actual del vehículo, etc.) previa solicitud y si están disponibles.',
      text19: '1.4.2.	La solicitud debe ser enviada a CFMOTO por el Cliente a través del distribuidor local / socio de ventas indicado en el Acuerdo de Venta de Vehículos.',
      text20: '1.5.	Reporte de problemas post-venta .',
      text21: '1.5.1.	CFMOTO recopila de forma remota las notificaciones de códigos de error enviadas por el Vehículo en caso de mal funcionamiento de sus componentes y proporciona la información respectiva a pedido del Cliente directamente al Cliente.',
      text22: '1.5.2.	La solicitud debe ser enviada a CFMOTO por el Cliente a través del distribuidor local / socio de ventas indicado en el Acuerdo de Venta de Vehículos.',
      text23: '2.	Restricciones y Exclusiones del Servicio',
      text24:
        '2.1.	Se señala expresamente que los cambios estructurales u otros técnicos en el Vehículo pueden limitar la prestación de los servicios o incluso imposibilitarla, ya que los servicios dependen de la correcta provisión de los datos del vehículo.',
      text25: '2.2.	Cuando dichos servicios no puedan prestarse debido al rendimiento de redes de datos o telecomunicaciones de terceros , se excluye cualquier responsabilidad de CFMOTO.',
      text26: '3.	Privacidad',
      text27:
        'CFMOTO cumplirá con las normas de protección de datos aplicables al procesar datos personales en relación con el vehículo CFMOTO . Los términos de la política de privacidad de C FMOTO se establecen en esta APLICACIÓN CFMOTO RIDE . Como complemento a la política de privacidad , este aviso cumple con la política de privacidad . Y el Cliente puede consultar la política de privacidad para algunos contenidos relacionados con el procesamiento de datos no cubiertos por este aviso.',
      text28: '4.	Servicio al Cliente',
      text29:
        '4.1.	El Cliente puede enviar preguntas, comentarios o inquietudes relacionadas con la privacidad a CFMOTORIDEAPP@cfmotousa.com o escribir a: CFMOTO Powersports, Inc., 3555 Holly Lane North, Suite 30, Plymouth, M N 55447. El Cliente también puede llamar Atención al cliente de CFMOTO al (888) 823-6686.',
      text30: '5.	R evisiones',
      text31: '5.1.	CFMOTO se reserva el derecho de cambiar este aviso en cualquier momento, pero publicaremos revisiones en CFMOTO RIDE App y/o avisar antes de que lo hagamos, según corresponda.',
    },
    atmosphere: {
      desTitle: '功能说明',
      setINfo: 'Las nuevas configuraciones surtirán efecto dentro de 1 a 3 minutos después de encender el vehículo, asegúrese de que el vehículo esté en una buena posición de señal',
      setSuccess: 'Fijado correctamente',
      sure: 'Claro',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      cContent: 'La configuración aún no se ha guardado, ¿quieres guardarla?',
      save: 'Guardar ajustes',
      introduce1: 'Cerca de instrucciones de desbloqueo automático',
      introduce2: 'instrucciones de apagado automático',
      introduce3: 'Instrucciones de activación automática',
      introduce4: 'Apagado de luces retrasado',
      content1: {
        msg1: 'Una vez activada la función, el teléfono móvil enciende el Bluetooth y la APLICACIÓN sigue funcionando. Al acercarse al vehículo de lejos a cerca, el vehículo se puede desbloquear y encender automáticamente.',
        msg2: 'Si normalmente no está desbloqueado y encendido, presione el botón de encendido del vehículo para desbloquear y encender',
        msg3: 'El desbloqueo automático de proximidad solo se activará una vez antes de que se desconecte el bluetooth',
      },
      content2: {
        msg1: 'Após a função ser ligada, o veículo desligará automaticamente após 5 segundos após as três condições do veículo serem desligadas, a velocidade do veículo é 0 e O templo caiu',
        msg2: 'Iniciar o veículo durante o período de desligamento automático, a velocidade do veículo não é 0 ou a têmpora é colocada cancelará o desligamento automático ...',
      },
      content3: {
        msg1: 'Una vez encendida la función, cuando el vehículo está apagado, el teléfono móvil enciende el Bluetooth y la APLICACIÓN sigue funcionando o lleva la tecla física. Al acercarse al vehículo de lejos a cerca, las luces del vehículo parpadearán para dar la bienvenida a los invitados.',
        msg2: 'Para evitar que los disparadores frecuentes provoquen una pérdida de potencia del vehículo, después de que la función de bienvenida se active dos veces en 30 segundos, no se reanudará hasta 30 minutos después.',
      },
      content4: {
        msg1: 'Después de encender la función, las luces de haz bajo y lejano se encenderán automáticamente durante 10 segundos después de que el vehículo se apague',
      },
    },
    feedback: {
      label: {
        type: 'Tipo de retroalimentación (opción única)',
        content: 'Descripción del problema',
        fileList: 'Por favor, suba una foto',
        fileList2: '(Máximo 4 fotos / 1 vídeo)',
        feedbackCreate: 'Haga clic en los comentarios',
        feedbackSupplement: 'Comentarios adicionales',
        backHome: 'Volver a la página de inicio',
        vehicle: 'vehículo asociado',
        selectVehicle: 'seleccionar vehículo',
      },
      placeholder: {
        'content.bug': 'Por favor, describa detalladamente la hora de ocurrencia, la versión de la APP, el modelo de teléfono móvil, la ruta de funcionamiento y la descripción del problema para ayudar a localizar y solucionar rápidamente el problema.',
        'content.suggest': 'Bienvenido a hacer valiosas sugerencias, consideraremos seriamente sus ideas',
        'content.vehicle': 'Por favor, describa cuándo ocurrió, cómo ocurrió y el problema',
        'content.other': 'Por favor, describa cuándo ocurrió, cómo ocurrió y el problema',
        'content.supplement': 'Por favor agregue una descripción del problema',
        vehicle: 'Por favor seleccione un vehículo',
      },
      rules: {
        'type.required': 'Seleccione el tipo de pregunta',
        'content.required': 'Por favor, introduzca una descripción de su problema',
        'fileList.uploading': 'Cargando, por favor espere',
        'fileList.maxSize': 'Archivo de carga demasiado grande',
        'fileList.overType': 'Formato no soportado',
        'fileList.maxCount': 'El número de cargas supera el límite',
        'fileList.acceptImageVideo': 'No se puede seleccionar el vídeo al seleccionar las imágenes',
        'vehicle.required': 'Por favor seleccione un vehículo',
      },
      message: {
        empty: 'En este momento no hay registros de retroalimentación.',
        finish: 'todo aquí',
        loading: 'Cargado',
        uploadFailed: 'Fallo de carga',
        tip: 'Para proteger la seguridad de su cuenta, le rogamos que no envíe aquí información personal sensible, como contraseñas de cuentas, etc.',
        feedbackSuccess: 'Comentarios recibidos',
        'submit.error': 'Fallo de retroalimentación',
        'submit.success': 'Comentarios recibidos',
      },
    },
    guide: {
      label: { giveFeedback: 'Sin resolver, quiero dar mi opinión' },
    },
    help: {
      label: {
        history: 'Buscar registros',
        cancel: 'Anular',
        yes: 'Sí',
        no: 'No',
        unresolved: '¿Aún no puedes resolver? Hacer clic',
        submitFeedback: 'Enviar comentarios',
      },
      placeholder: {
        search: 'Buscar',
        'content.required': 'Introduzca palabra clave',
      },
      message: {
        empty: 'Sin contenido relacionado',
        empty2: 'Sugerir cambiar palabras clave o',
        finish: 'todo aquí',
        historyDelete: '¿Eliminar todos los registros de búsqueda?',
        isHelpful: '¿Ayuda?',
      },
    },
    unbinding: {
      label: {
        vin: 'N° de ID del veh.',
        realName: 'Nombre completo',
        email: 'Correo electrónico',
        phone: 'Número de teléfono',
        areaCode: 'Código de país',
        identity: 'Identificación',
        drivingLicense: 'Certificado de Registro de Vehículo.',
        backHome: 'Volver a la página de inicio',
        areaCodeTitle: 'Código de país',
        latterTitle: 'Aviso',
        agree: 'Aprobar',
        disagree: 'En desacuerdo',
        agreeCheckLabel: 'He leído y accedo a',
        agreeCheckTitle: 'Instrucciones para solicitar la desvinculación de vehículos',
      },
      placeholder: {
        vin: 'Por favor ingrese el VIN',
        realName: 'Por favor ingrese su nombre real',
        email: 'Por favor, introduzca su dirección de correo electrónico',
        phone: 'Por favor, introduzca su número de teléfono',
        identity: 'Página principal del carné de identidad, licencia de conducir o pasaporte que contiene información de identificación personal.',
        drivingLicense: 'Página principal del Certificado de Registro de Vehículo con el nombre del propietario y el número de identificación del vehículo (VIN).',
      },
      rules: {
        'agree.required': 'Por favor, lea y acepte',
        'vin.required': 'Por favor ingrese el VIN',
        'vin.pattern': 'VIN incorrecto, por favor, verifica.',
        'realName.required': 'Por favor ingrese su nombre real',
        'email.required': 'Por favor, introduzca su dirección de correo electrónico',
        'email.pattern': 'El formato de la dirección de correo electrónico es incorrecto, por favor verifique.',
        'phone.required': 'Por favor, introduzca su número de teléfono',
        'phone.pattern': 'Error en el formato del número de teléfono, compruébelo',
        'fileList.maxCount': 'El número de cargas supera el límite',
        'fileList.uploading': 'Cargando, por favor espere',
      },
      message: {
        imgUploadFailed: 'Error de subida de imagen',
        securityMessage: 'La información anterior se utiliza únicamente para verificación de identidad. CFMOTO protege su información.',
        resultMessage: 'Verificaremos los materiales de la aplicación lo antes posible, preste atención a la barra de notificaciones o al centro de mensajes de la aplicación a tiempo.',
        loading: 'Cargado',
      },
    },
  },
};
